import TOCEntry from './TOCEntry'

export default TOCEntry
